import './polyfill.ts';
import { MaintenancePage } from '@magicdoorinc/ui';
import { Router } from '@solidjs/router';
import { Show } from 'solid-js';
import { render } from 'solid-js/web';
import './index.css';
import { AuthGuard } from '~/components/auth/AuthGuard.jsx';
import { installHoaThemeOverrides, IS_HOA_DEMO_MODE } from '~/utils/hoaDemoMode';
import { initI18n } from '~/utils/i18n';
import { initSentry } from '~/utils/sentry';
import { initVConsole } from '~/utils/vconsole';
import { hookVersionInfo } from '~/utils/versionManagement.2';
import App from './App';
import { GlobalProviders } from './contexts/global';

initSentry();
void initVConsole();

if (IS_HOA_DEMO_MODE) {
  document.title = 'HOA Portal';
  installHoaThemeOverrides();
}

const root = document.getElementById('root');

if (import.meta.env.DEV && !(root instanceof HTMLElement)) {
  throw new Error('Root element not found. Did you forget to add it to your index.html? Or maybe the id attribute got mispelled?');
}

const mount = () =>
  render(() => {
    const versionInfo = hookVersionInfo();

    return (
      <Router>
        <Show when={!versionInfo.shouldShowMaintenance()} fallback={<MaintenancePage />}>
          <AuthGuard>
            <GlobalProviders>
              <App />
            </GlobalProviders>
          </AuthGuard>
        </Show>
      </Router>
    );
  }, root!);

void initI18n().then(mount);
